<template>
  <div class="times_container top-left w50 right margin margin_r_hf margin_l_c">
    <bottom-times-chart v-if="mainView === null"></bottom-times-chart>
  </div>
</template>

<script>
import BottomTimesChart from "../components/BottomTimesChart.component";
import {mapState} from "vuex";

export default {
  name: "GraphBottomTimes.container",
  components: {
    BottomTimesChart
  },
  computed:{
    ...mapState("tasks" , ["chartsViewBlocks"])
  },
  data(){
    return{
      mainView: null
    }
  },
  watch: {
    chartsViewBlocks: function (){
      this.mainView = this.chartsViewBlocks[4];
    }

  }


};
</script>

<style scoped>
.times_container {
  width: 44.8%;
}
.right {
  float: right;
}
.margin {
  /*margin: 0.5rem;*/
}
.margin_r_hf {
  /*margin-right: 0;*/
}
.margin_l_c {
  /*margin-left: 0.2rem;*/
}
.styleCard {
  /*box-shadow: 0px 9px 20px rgba(0, 0, 0, 0.05);*/
  border-radius: 0px;
  height: 300px;
  font-family: Montserrat;
}
</style>
